import App from "../app";
import { AttemptId, ProductId, ItemId, QuizId } from "../model/datasource";

export default abstract class Controller<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> {
	abstract bind(target: EventTarget, app: App<P, A, Z, I>): void
}